import 'css/admin.css';
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { Login } from "../pages/login/Login";
import { OrderList } from '../pages/order/OrderList';
import { Reservation } from '../pages/settings/Reservation';
import { Password } from '../pages/settings/Password';
import { Mail } from '../pages/settings/Mail';
import { Company } from '../pages/settings/Company';
import { Tax } from '../pages/settings/Tax';
import { ScheduleList } from '../pages/schedule/ScheduleList';
import { CategoryList } from '../pages/category/CategoryList';
import { OptionList } from '../pages/option/OptionList';
import { ServiceList } from '../pages/service/ServiceList';
import { OrderCalendar } from '../pages/calendar/OrderCalendar';
import { CtxAuth } from 'views/utils/Contexts';
import { useAuth } from 'views/utils/UseAuth';
import { ScheduleEdit } from '../pages/schedule/ScheduleEdit';
import { CategoryEdit } from '../pages/category/CategoryEdit';
import { OptionEdit } from '../pages/option/OptionEdit';
import { ServiceEdit } from '../pages/service/ServiceEdit';
import { OrderEdit } from '../pages/order/OrderEdit';
import { Error } from "views/guest/pages/error/Error";
import { NonBusiness } from '../pages/nonbusiness/NonBusiness';

export function AdminLayout(): JSX.Element{

    const ua = useAuth();
    //ログイン判定
    if (window.location.pathname.indexOf('/admin/login') === -1){
        ua.isLoggedIn(
            function(res:any){
                if( res === false ){
                    //有効期限切れまたは未ログイン
                    window.location.href = process.env.PUBLIC_URL + '/admin/login';
                }
            });
    }

    return (
        <CtxAuth.Provider value={ua}>
            <BrowserRouter basename={process.env.PUBLIC_URL}>
                <Switch>
                    <Route exact path='/admin/login' component={Login}/>
                    <Route exact path='/admin/order/list' component={OrderList}/>
                    <Route exact path='/admin/order/edit' component={OrderEdit}/>
                    <Route exact path='/admin/calendar' component={OrderCalendar}/>
                    <Route exact path='/admin/service/list' component={ServiceList}/>
                    <Route exact path='/admin/service/edit' component={ServiceEdit}/>
                    <Route exact path='/admin/option/list' component={OptionList}/>
                    <Route exact path='/admin/option/edit' component={OptionEdit}/>
                    <Route exact path='/admin/category/list' component={CategoryList}/>
                    <Route exact path='/admin/category/edit' component={CategoryEdit}/>
                    <Route exact path='/admin/schedule/list' component={ScheduleList}/>
                    <Route exact path='/admin/schedule/edit' component={ScheduleEdit}/>
                    <Route exact path='/admin/nonbusiness' component={NonBusiness}/>
                    <Route exact path='/admin/settings/password' component={Password}/>
                    <Route exact path='/admin/settings/company' component={Company}/>
                    <Route exact path='/admin/settings/mail' component={Mail}/>
                    <Route exact path='/admin/settings/reservation' component={Reservation}/>
                    <Route exact path='/admin/settings/tax' component={Tax}/>
                    <Route><Error type="notfound_error"/></Route>
                </Switch>
            </BrowserRouter>
        </CtxAuth.Provider>
    )

}